export default "__VITE_ASSET__CVyLWKsC__"